<template>
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.2875 4.3125H9.79688V5.75H11.2875V4.3125Z" fill="#4B79F0" />
    <path
      d="M10.5435 0C4.80475 0 0.109375 4.52813 0.109375 10.0625C0.109375 15.5969 4.80475 20.125 10.5435 20.125C16.2823 20.125 20.9777 15.5969 20.9777 10.0625C20.9777 4.52813 16.2823 0 10.5435 0ZM10.5435 18.6875C5.62457 18.6875 1.59997 14.8062 1.59997 10.0625C1.59997 5.31875 5.62457 1.4375 10.5435 1.4375C15.4625 1.4375 19.4871 5.31875 19.4871 10.0625C19.4871 14.8062 15.4625 18.6875 10.5435 18.6875Z"
      fill="#4B79F0"
    />
    <path d="M11.2875 7.1875H9.79688V15.8125H11.2875V7.1875Z" fill="#4B79F0" />
  </svg>
</template>

<script>
export default {
  name: 'InfoButton'
}
</script>

<style scoped>

</style>
